export const categories = [
  { id: "wanghong-tafang", name: "网红塌房", slug: "wanghong-tafang", description: "网红翻车现场直击，塌房实录第一时间报道", icon: "ri-alert-line" },
  { id: "chigua-baoliao", name: "吃瓜爆料", slug: "chigua-baoliao", description: "最新最全娱乐圈爆料，吃瓜群众第一线", icon: "ri-chat-smile-2-line" },
  { id: "mingxing-bagua", name: "明星八卦", slug: "mingxing-bagua", description: "明星私生活、恋情、争议全收录", icon: "ri-star-line" },
  { id: "zhibo-fanju", name: "直播翻车", slug: "zhibo-fanju", description: "直播间事故、主播翻车名场面", icon: "ri-live-line" },
  { id: "shejiao-reshi", name: "社交热事", slug: "shejiao-reshi", description: "微博抖音小红书热搜背后的故事", icon: "ri-fire-line" },
  { id: "meiri-dasai", name: "每日黑料大赛", slug: "meiri-dasai", description: "每日黑料大赛入口，投出你的一票", icon: "ri-trophy-line" },
];

export const tags = [
  "塌房", "爆红", "争议", "恋情", "翻车", "道歉", "黑历史", "聊天记录",
  "实锤", "反转", "退网", "复出", "打假", "人设崩塌", "私生活",
];

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  categoryId: string;
  tags: string[];
  coverImage: string;
  author: string;
  publishDate: string;
  viewCount: number;
  commentCount: number;
  isHot: boolean;
  isFeatured: boolean;
  readTime: number;
}